export default __webpack_public_path__ + "static/media/journeytray-bluetree-nut.de2456cc.svg";